<script lang="ts">
	import { override } from '$lib/utils/classnames'
	import { twMerge } from 'tailwind-merge'

	interface Props {
		width?: string
		height?: string
		borderRadius?: string
		baseColor?: string
		highlightColor?: string
		animationLength?: string
		class?: string
	}

	let {
		width = '100%',
		height = '25px',
		borderRadius = '4px',
		baseColor = 'rgb(47, 45, 45)',
		highlightColor = 'rgb(62, 60, 60)',
		animationLength = '1.2s',
		class: className = '',
	}: Props = $props()

	let newClasses = $derived(twMerge(override('skeleton', className)))
</script>

<div
	class={newClasses}
	style="height: {height}; width: {width}; border-radius: {borderRadius}; --baseColor: {baseColor}; --highlightColor: {highlightColor}; --animationLength: {animationLength}"
></div>

<style>
	.skeleton {
		background-color: var(--baseColor);
		background-image: linear-gradient(
			90deg,
			var(--baseColor),
			var(--highlightColor),
			var(--baseColor)
		);
		background-size: 200px 100%;
		background-repeat: no-repeat;
		/* display: inline-block; */
		width: 100%;
		animation: loading-animation var(--animationLength) ease-in-out infinite;
	}

	@keyframes loading-animation {
		0% {
			background-position: -200px 0;
		}
		100% {
			background-position: calc(200px + 100%) 0;
		}
	}
</style>
